export default {
    install(Vue: any, options: any) {
        Vue.mixin({
            data() {
                return {
                    isMobile: false,
                }
            },
            mounted() {
                if (options && options.breakpoint) {
                    this.isMobile = window.innerWidth < options.breakpoint

                    window.addEventListener('resize', (e: any) => {
                        const windowWidth = e.target.innerWidth
                        this.isMobile = windowWidth < options.breakpoint
                    })
                } else {
                    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                        navigator.userAgent
                    )
                }
            },
        })
    },
}
